import { SectionHeading } from './SectionHeading'

// "Jnati Key Features" — 6 cards in a 3×2 grid on desktop, 2-col on
// tablet, 1-col on mobile (#7r2). Copy verbatim from marketing.
//
// Visual treatment per audit: navy-on-navy cards (`bg-navy`) with gold
// title + white body + heavy shadow. Depth comes from the shadow on
// the navy field, not background tint.

const FEATURES: Array<{ title: string; body: string }> = [
  { title: 'Private & Secure Network',  body: 'Only real relatives — no strangers, no ads, no public posts.' },
  { title: 'Smart Search & Suggestions', body: 'Find relatives by name or location. Let Jnati suggest likely matches.' },
  { title: 'Invite via WhatsApp',        body: 'Easily invite family members directly using WhatsApp.' },
  { title: 'Visual Family Graphs',       body: 'Explore connections in dynamic visual graphs.' },
  { title: 'Post only to Circles',       body: 'Share stories and updates — only with selected relatives.' },
  { title: 'Add Dependent Relatives',    body: 'Manually add elderly or unlisted family members.' },
]

export function FeaturesSection() {
  return (
    <section className="py-12 sm:py-16 px-4">
      <div className="max-w-5xl mx-auto">
        <SectionHeading id="features">Jnati Key Features</SectionHeading>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {FEATURES.map((f) => (
            <div
              key={f.title}
              className="bg-navy text-white rounded-xl p-5 text-center shadow-[0_4px_8px_rgba(0,0,0,0.6)] border border-white/5"
            >
              <h3 className="text-gold text-base font-bold mb-2">{f.title}</h3>
              <p className="text-white/90 text-sm leading-relaxed">{f.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
